<template>
  <div class="profile">
    <header-bar></header-bar>

    <section class="profile-header">
      <div class="grid-inner">
        <div class="col-6">
          <div class="image-circle">
          </div>
          <div class="info">
          </div>
        </div>
        <div class="col-6" v-if="hasIdea">
          <h2>Countries</h2>
          <p></p>
        </div>
      </div>
    </section>

    <section class="profile-body">
      <div class="grid-inner">
        <div class="col-5">

          <h4 v-if="countries">Regions of interest:</h4>

          <div>
            
            <country v-for="item, key in countries" :key="key" :itemid="key"></country>

          </div>

        </div>



      </div>
    </section>

  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'
import Country from '@/components/profile/Country'

export default {
  data () {
    return {
      favourited: null
    }
  },
  components: {
    HeaderBar,
    Country
  },
  firebase: function () {
    return {
      countries: {
        source: db.ref('attributes/countries'),
        asObject: true
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// CountriesExample.vue?3cdc1715